/**** Delivery pincode triggers (header / PDP): sync label with localStorage *****/

/**** Generic show/hide helpers (legacy inline onclick) *****/
function showPopup(popupId) {
  const el = document.getElementById(popupId);
  if (el) el.style.display = 'block';
}

function closePopup(popupId) {
  const el = document.getElementById(popupId);
  if (el) el.style.display = 'none';
}

document.addEventListener('DOMContentLoaded', () => {
  const heading = document.querySelector('.clickpost-edd__heading');
  const form = document.querySelector('.clickpost-edd__form');

  if (heading && form) {
    heading.addEventListener('click', () => {
      form.classList.toggle('show');
    });
  }

  const triggers = [
    document.getElementById('UpdatePincodeTrigger'),
    document.getElementById('UpdatePincodeTriggerDesktop')
  ];

  const PINCODE_KEY = 'delivery_pincode';

  function updateTriggerText(pincodeFromEvent) {
    let pincode = pincodeFromEvent;
    if (pincode == null || String(pincode).trim() === '') {
      try {
        pincode = localStorage.getItem(PINCODE_KEY);
      } catch (e) {
        pincode = null;
      }
    }
    if (!pincode) return;

    triggers.forEach(trigger => {
      if (!trigger) return;

      const textEl = trigger.querySelector('.text');
      if (textEl) {
        textEl.textContent = `Delivering to ${pincode}`;
      }
    });
  }

  function onPincodeUpdated(e) {
    const pin = e && e.detail && e.detail.pincode;
    if (pin) {
      updateTriggerText(pin);
    } else {
      updateTriggerText();
    }
  }

  updateTriggerText();

  /* Unified sheet (`sdd-popup`) dispatches both events on submit; listen once to avoid double updates. */
  document.addEventListener('delivery-pincode-updated', onPincodeUpdated);

  window.addEventListener('storage', () => {
    updateTriggerText();
  });

  triggers.forEach(trigger => {
    if (!trigger) return;

    trigger.addEventListener('click', () => {
      if (typeof window.openPincodeSheet === 'function') {
        window.openPincodeSheet();
      }
    });

    trigger.addEventListener('keydown', e => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        if (typeof window.openPincodeSheet === 'function') {
          window.openPincodeSheet();
        }
      }
    });
  });
});
